import React from "react";

const Media = () => {
    return (
        <div>
            <h1>Media</h1>
            <p>Welcome to the Media page.</p>
        </div>
    );
};

export default Media;